import { render } from "./HeroiconsOutlineIdentification.vue?vue&type=template&id=68fb8fdf"
const script = {}

import exportComponent from "/home/tobias/Desktop/screenads/nova-custom2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineIdentification.vue"]])

export default __exports__